if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.container = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-media-nav="prev"]');
        this.nextButton = this.querySelector('[data-media-nav="next"]');
        this.progressCurrent = this.querySelector('[data-media-progress-current]');
        this.progressTotal = this.querySelector('[data-media-progress-total]');
        this.zoomedImage = null;
        this.zoomScale = 2;

        [this.prevButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.changeMedia(button.dataset.mediaNav === 'next' ? 1 : -1);
          });
          button.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
        });

        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.container?.addEventListener('click', this.onImageClick.bind(this));
        this.container?.addEventListener('mousemove', this.onImageMouseMove.bind(this));
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.mediaItems = this.getMediaItems();
        this.showActiveMedia(opener?.getAttribute('data-media-id'));
      }

      getMediaItems() {
        if (!this.container) return [];
        return Array.from(this.container.children).filter(
          (element) => element.nodeType === 1 && element.hasAttribute('data-media-id')
        );
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.changeMedia(1);
        }
        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.changeMedia(-1);
        }
      }

      showActiveMedia(mediaId) {
        if (!this.mediaItems || this.mediaItems.length === 0) {
          this.mediaItems = this.getMediaItems();
        }
        if (!this.mediaItems || this.mediaItems.length === 0) return;

        let activeMedia = this.mediaItems.find((element) => element.getAttribute('data-media-id') === mediaId);
        if (!activeMedia) activeMedia = this.mediaItems[0];

        this.mediaItems.forEach((element) => element.classList.remove('active'));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.resetZoom();
        this.currentIndex = this.mediaItems.indexOf(activeMedia);
        this.updateNavButtons();
        this.updateProgress();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      changeMedia(step) {
        if (!this.mediaItems || this.mediaItems.length < 2) return;
        this.resetZoom();
        window.pauseAllMedia();
        const total = this.mediaItems.length;
        const nextIndex = (this.currentIndex + step + total) % total;
        const nextMedia = this.mediaItems[nextIndex];
        this.showActiveMedia(nextMedia.getAttribute('data-media-id'));
      }

      updateNavButtons() {
        const hasMultipleMedia = this.mediaItems && this.mediaItems.length > 1;
        [this.prevButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.toggleAttribute('hidden', !hasMultipleMedia);
        });
      }

      updateProgress() {
        if (!this.progressCurrent || !this.progressTotal) return;
        const total = this.mediaItems ? this.mediaItems.length : 0;
        const current = total > 0 && this.currentIndex >= 0 ? this.currentIndex + 1 : 1;
        this.progressCurrent.textContent = `${current}`;
        this.progressTotal.textContent = `${Math.max(total, 1)}`;
      }

      onImageClick(event) {
        const image = this.mediaItems && this.currentIndex >= 0 ? this.mediaItems[this.currentIndex] : null;
        if (!image) return;
        if (image.nodeName !== 'IMG') return;
        event.preventDefault();
        event.stopPropagation();

        if (this.zoomedImage === image) {
          this.resetZoom();
          return;
        }

        this.resetZoom();
        this.zoomedImage = image;
        image.classList.add('is-zoomed');
        image.style.transform = `scale(${this.zoomScale})`;
        image.style.willChange = 'transform';
        this.updateZoomOrigin(event);
      }

      onImageMouseMove(event) {
        if (!this.zoomedImage) return;
        this.updateZoomOrigin(event);
      }

      updateZoomOrigin(event) {
        if (!this.zoomedImage) return;
        const rect = this.zoomedImage.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        const clamp = (value) => Math.max(0, Math.min(100, value));
        this.zoomedImage.style.transformOrigin = `${clamp(x)}% ${clamp(y)}%`;
      }

      resetZoom() {
        if (!this.zoomedImage) return;
        this.zoomedImage.classList.remove('is-zoomed');
        this.zoomedImage.style.transform = '';
        this.zoomedImage.style.transformOrigin = '';
        this.zoomedImage.style.willChange = '';
        this.zoomedImage = null;
      }
    }
  );
}
